import Swiper from "swiper";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

export function initImageTextBlockSlider() {
    const imageTextBlockSliders = document.querySelectorAll(".pul-image-text-block .swiper");

    if (imageTextBlockSliders.length > 0) {

        for (const imageTextBlockSlider of imageTextBlockSliders) {
            const prevEl = imageTextBlockSlider.closest(".pul-image-text-block").querySelector(".swiper-button-prev");
            const nextEl = imageTextBlockSlider.closest(".pul-image-text-block").querySelector(".swiper-button-next");

            if (imageTextBlockSlider.querySelectorAll(".swiper-slide").length === 1) {
                imageTextBlockSlider.closest(".pul-image-text-block__slider").classList.add("single-slide");
            }

            const slider = new Swiper(imageTextBlockSlider, {
                modules: [Autoplay, Navigation, Pagination],
                slidesPerView: 1,
                spaceBetween: 16,
                autoplay: {
                    delay: 3000
                },
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                navigation: {
                    prevEl: prevEl,
                    nextEl: nextEl
                },
            });
        }
    }
}